import axios from 'axios'
import cuid from 'cuid'
import qs from 'qs'
import { captureException } from '@sentry/browser'

const instance = axios.create()

const serialize = (params) => {
  return qs.stringify(params, {
    arrayFormat: 'brackets',
    encodeValuesOnly: true
  })
}

const handleSuccesfulResponse = (response) => {
  const headers = response.headers
  const store = window.store || window.booqableStore
  const state = store.getState()

  const token = headers['Session-Expiry-Token'] || headers['session-expiry-token']
  const clientVersion = headers['Client-Version'] || headers['client-version']
  const readOnlyMode = (headers['X-Read-Only-Mode'] || headers['x-read-only-mode']) === 'true'

  if (state.session?.token !== token) {
    store.dispatch({ type: 'SET_TOKEN', payload: { token } })
  }

  if (state.session?.clientVersion !== clientVersion) {
    store.dispatch({ type: 'SET_CLIENT_VERSION', payload: { client_version: clientVersion } })
  }

  if (state.session?.readOnlyMode !== readOnlyMode) {
    store.dispatch({ type: 'SET_READ_ONLY_MODE', payload: { read_only_mode: readOnlyMode } })
  }

  return response
}

const handleUnauthorizedResponse = () => {
  window.skipUnsavedChangesCheck = true
  window.location.reload()
}

const handleServiceUnavailableResponse = (error) => {
  window.store?.dispatch({
    type: 'SERVICE_UNAVAILABLE_ERROR',
    payload: { error: error.response.data }
  })
}

const handle500Errors = (error) => {
  captureException(error, error.response)
}

const handleFailureResponse = (error) => {
  const status = error?.response?.status

  if (status === 401) handleUnauthorizedResponse()

  if (status >= 500) handle500Errors(error)

  if (status === 503) handleServiceUnavailableResponse(error)

  return Promise.reject(error)
}

// Format nested params correctly
instance.interceptors.request.use((config) => {
  config.paramsSerializer = { serialize }

  return config
})

// This header allows pusher/orm.js
// to ignore events triggered by the current browser window
instance.interceptors.request.use((config) => {
  window.booqablePusherSessionId ||= cuid()
  config.headers.common['X-Booqable-Pusher-Session-Id'] = window.booqablePusherSessionId

  return config
})

// Inject the storefront token
instance.interceptors.request.use((config) => {
  if (window.fingerprint) {
    config.headers.common['X-Booqable-Storefront-Token'] = window.fingerprint
  }

  return config
})

// Inject the CSRF token
instance.interceptors.request.use((config) => {
  const tokenElement = document.querySelector('meta[name="csrf-token"]')
  if (tokenElement) {
    const token = tokenElement.getAttribute('content')
    config.headers['X-CSRF-Token'] = token
  }

  return config
})

instance.interceptors.response.use(
  handleSuccesfulResponse,
  handleFailureResponse
)

export default instance
